import React from 'react';

const Navigation = ({activeQuestion, responcesProgress, actionPrevQuestion, actionNextQuestion}) => (
  <div className="quiz--navigation">
    <div className="container">
      <div className="d-flex justify-content-between">
        <button
          type="button"
          class="previous-post btn btn-primary"
          onClick={() => actionPrevQuestion() }
          disabled={(activeQuestion < 2)}
        >
          {lang.BACK}
        </button>

        <button
          type="button"
          className="next-post btn btn-primary"
          onClick={() => actionNextQuestion()}
          disabled={(responcesProgress < activeQuestion)}
        >
          {lang.NEXT_SECTION}
        </button>
      </div>
    </div>
  </div>
);

export default Navigation;